export default __webpack_public_path__ + "static/106-130b246f150ad9f2177a2a7454cd92cf.jpg";